export default {
  get (name) {
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    let arr = document.cookie.match(reg)
    if (arr) {
      return (arr[2])
    } else {
      return null
    }
  },
  set (name, value, expiresIn) {
    document.cookie = name + '=' + escape(value) + ';expires=' + expiresIn
  },
  del (name) {
    let exp = new Date()
    exp.setTime(exp.getTime() - 1)

    let val = this.get(name)
    if (val != null) {
      document.cookie = name + '=' + val + ';expires=' + exp.toGMTString()
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/Cookie.js